export default __webpack_public_path__ + "assets/thibaud.f5521648.jpg";